<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TjgRvB/tc-custom/9781631950353.jpg?1736221294843" alt="This image is the cover for the book Motivating Adolescents"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Motivating Adolescents
      </h1>
      <p class="bookDescription body article font2">
        <p>Learn how to motivate your adolescent and set them up for success!</p><p><br/><br/>Are you frustrated by your teen‚Äôs lack of interest in education and their future? Do you find yourself getting upset with a broken education system that seems like it‚Äôs doing nothing to help them? Learn about a new movement that is helping adolescents ignite their passion for life from within and achieve their full potential.</p><p><br/><br/>Motivating Adolescents introduces the EMERGING process, which draws on the wisdom of philosophers and social reformers, such as Rudolf Steiner, Ralph Waldo Emerson, Joseph Campbell, Goethe, and Plato, to help parents set their adolescent up for a successful future with confidence, mindfulness, and passion. Throughout Motivating Adolescents, twenty-year veteran Waldorf teacher and international speaker, Robin Theiss helps parents and their teens:</p><p><br/><br/></p>Understand the purpose of education and its role in a successful future<br/>Learn the importance of mindfulness and cultivating a rich inner life<br/>Embrace the value of risk-taking and grit<br/>Value authentic relationships, and cultivate appreciation and gratitude<br/>Experience nature as the ultimate teacher of lifelong learning and inquiry<p><br/><br/>Motivating Adolescents gives you and your teen the wisdom and skills they need to be engaged citizens of the world. Don't delay your teen's future another day!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robin Theiss
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?91ae99a8